export function webTrackingTransition({ on, tripId = null, currentTripId = null, hasPuck = false } = {}) {
  const tracking = !!on
  const resolvedTripId = tracking ? (tripId ?? currentTripId) : null
  // Turning on with the SAME trip id is a re-announce (e.g. the tracker
  // answering the map's query-tracking after a mid-trip Turbo re-navigation),
  // not a new trip: the odometer and the follow camera must not reset.
  const sameTrip = tracking && resolvedTripId != null && currentTripId != null &&
    String(resolvedTripId) === String(currentTripId)
  return {
    tracking,
    tripId: resolvedTripId,
    sameTrip,
    presenceKick: true,
    hudVisible: tracking,
    followButtonVisible: tracking,
    stopGeoWatch: tracking,
    resetOdometer: tracking && !sameTrip,
    hudDistanceText: tracking && !sameTrip ? "0.0" : null,
    zoomedToFollow: tracking ? undefined : false,
    removePuck: !tracking && hasPuck,
    cameraEvent: tracking ? (sameTrip ? null : "TRACKING_STARTED") : "TRACKING_STOPPED",
    renderOrient: true
  }
}
